import _throttle from 'lodash/throttle';
import Swiper from 'swiper';
import PinchZoom from 'pinch-zoom-js';

// Przewijanie górnego paska.
(() => {
    let top = document.querySelector('nav.top'),
        callback = () => {
            let scroll = (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0);

            if (scroll === 0 && top.classList.contains('top--white')) {
                top.classList.remove('top--white');
            }

            if (scroll > 0 && !top.classList.contains('top--white')) {
                top.classList.add('top--white');
            }
        };

    if (!top.classList.contains('top--white')) {
        callback();
        window.addEventListener('scroll', _throttle(callback, 100));
    }
})();

// Obsługa menu mobilnego.
(() => {
    let trigger = document.querySelector('.top__right_mobile a'),
        menu = document.querySelector('.top__mobile');

    trigger.addEventListener('click', (e) => {
        e.preventDefault();

        menu.classList.toggle('top__mobile--visible');
    });
})();

// Pokazywanie / ukrywanie zaawansowanego wyszukiwania.
(() => {
    let button = document.querySelector('.header__search_more a'),
        advancedSearchForm = document.querySelector('.header__search_advanced'),
        calculateHeight = (element) => {
            element.classList.add('header__search_advanced--calculate');
            let height = element.offsetHeight;
            element.classList.remove('header__search_advanced--calculate');

            return height;
        };

    if (button === null || advancedSearchForm === null) {
        return;
    }

    button.addEventListener('click', (e) => {
        e.preventDefault();

        button.style.visibility = 'hidden';

        let height = calculateHeight(advancedSearchForm);

        advancedSearchForm.classList.add('header__search_advanced--visible');
        window.setTimeout(() => {
            advancedSearchForm.style.height = (height + 2) + 'px';
        }, 1);


    });

    window.addEventListener('resize', _throttle(() => {
        if (advancedSearchForm.classList.contains('header__search_advanced--visible')
            && advancedSearchForm.style.height !== 'auto') {
            advancedSearchForm.style.height = 'auto';
        }
    }, 100));
})();

// Obsługa slidera.
(() => {
    let slider = document.querySelector('.header__slider > .swiper-container');

    if (slider !== null) {
        let swiper = new Swiper(slider, {
            spaceBetween: 20,
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
            loopedSlides: 8,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            }
        });

        slider.addEventListener('mouseenter', swiper.autoplay.stop);
        slider.addEventListener('mouseleave', swiper.autoplay.start);
    }
})();

// Pokazywanie selecta przy zmianie typu.
(() => {
    let triggers = document.querySelectorAll('.tickets__selected_change');

    if (triggers.length === 0) {
        return;
    }

    triggers.forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();

            link.style.display = 'none';
            link.parentElement.querySelector('.tickets__selected_type').style.display = 'inline-block';
        });
    });
})();

// Przykładowe powiększanie planu.
(() => {
    let halls = document.querySelectorAll('.hall');

    halls.forEach((hall) => {
        let zoom = new PinchZoom(hall),
            resetButtons = document.querySelectorAll('.hall__zoom_reset[data-zoom-id="' + hall.getAttribute('data-zoom-id') + '"]');

        resetButtons.forEach((resetButton) => {
            resetButton.addEventListener('click', (e) => {
                e.preventDefault();

                zoom.zoomOutAnimation();
            });
        });
    });
})();

(() => {
    let seats = document.querySelectorAll('.hall__seat');

    for (let i = 0; i < seats.length; i++) {
        let seat = seats[i];
        let sector = seat.getAttribute('data-sektor');

        seat.addEventListener('mouseenter', () => {
            let sectorSeats = document.querySelectorAll('.hall__seat[data-sektor="' + sector + '"]');

            for (let si = 0; si < sectorSeats.length; si++) {
                let sectorSeat = sectorSeats[si];

                sectorSeat.classList.add('hall__seat--hover');
            }
        });

        seat.addEventListener('mouseleave', () => {
            let sectorSeats = document.querySelectorAll('.hall__seat[data-sektor="' + sector + '"]');

            for (let si = 0; si < sectorSeats.length; si++) {
                let sectorSeat = sectorSeats[si];

                if (sectorSeat.classList.contains('hall__seat--hover')) {
                    sectorSeat.classList.remove('hall__seat--hover');
                }
            }
        });
    }
})();

// Klikanie miejsca.
// (() => {
//     let seats = document.querySelectorAll('.hall__seat--75, .hall__seat--55, .hall__seat--45');
//
//     for (let i = 0; i < seats.length; i++) {
//         let seat = seats[i];
//
//         if (seat.classList.contains('hall__seat--taken')) {
//             continue;
//         }
//
//         seat.addEventListener('click', function (e) {
//             e.preventDefault();
//
//             seat.classList.toggle('hall__seat--selected');
//         });
//     }
// })();


// WEBPACK FOOTER //
// ./public/assets/src/js/main.js